import React, { Component, Fragment } from 'react'
import { View, Text, Icon } from '../primitives'
import Select from '../Select'
import SelectLocation from '../SelectLocation'
import Option from '../Option'
import { ThemeProvider } from 'styled-components'
import { ThemeConsumer } from 'styled-components'

const Container = View.extend`
  display: flex;
  height: 28px;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
`

const Label = Text.extend`
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover {
    opacity: 0.65;
  }
`

const LabelChildren = Text.extend`
  position: relative;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 20px;
  &:hover {
    opacity: 0.65;
  }
  &::before {
    content: "- ";
    color: #d5d5d5;
    padding-left: 8px;
    margin-right: 8px;
  }
`

const IconBox = View.extend.attrs({ bg: 'accent3Color' })`
  display: inline-block;
  width: 16px;
  height: 16px;
  padding-top: 1px;
  margin-right: 10px;
  line-height: 0;
  border-radius: 2px;
`

const Check = Icon.extend.attrs()`
pointer-events: none;
position: relative;
left: 1px;
top: 0;
`

const Arrow = Icon.extend.attrs()`
position: relative;
left: 0px;
padding-left: 4px;
display: inline;
`

export default class OptionList extends Component {
  constructor(props) {
    super(props);

    this.childValues = this.props.subOptions.map(subValue =>  subValue.value)

    this.state = {
      subVisible: false,
      selectedChildren: this.createSelectedChildren()
    };

    this.createSelectedChildren = this.createSelectedChildren.bind(this)
  }

  createSelectedChildren() {
    const parent = this.props.selectedParent && this.props.selectedParent.find(value => this.props.value === value)
    if (parent) {
      return (this.childValues)
    } else if (!this.props.selectedChildren) {
      return []
    } else {
      return this.props.selectedChildren.filter(value => this.childValues.includes(value))
    }
  }

  getCurrentParentValue() {
    if (this.props.selectedParent) {      
      return this.state.selectedChildren.length === this.childValues.length ?
        !this.props.selectedParent.some(value => this.props.value === value) ? this.props.selectedParent : [...this.props.selectedParent,this.props.value]
        : this.props.selectedParent.filter(value => this.props.value !== value)
    } else {
      return this.state.selectedChildren.length === this.childValues.length ? [this.props.value] : []
    }
  }

  getCurrentChildValue() {
    if (this.props.selectedChildren) {      
      let selectedChildren = this.props.selectedChildren.filter(value => !this.childValues.includes(value))

      if (this.state.selectedChildren.length !== this.childValues.length) {
        selectedChildren.push(...this.state.selectedChildren)
      } 

      return selectedChildren
    } else {
      return this.state.selectedChildren.length === this.childValues.length ? [] : this.state.selectedChildren
    }
  }

  componentDidUpdate(prevProps,prevState) {    
    if (prevState.selectedChildren.length !== this.state.selectedChildren.length) {
      this.props.onChangeTree([
        {
          filter: this.props.parentFilter,
          values: this.getCurrentParentValue()
        },
        {
          filter: this.props.childFilter,
          values: this.getCurrentChildValue()
        }
      ])
    }
  }
  
  handleChild(value) {
    let selectedChildren = [...this.state.selectedChildren]
    if (selectedChildren.includes(value)) {
      selectedChildren = selectedChildren.filter(selectedValue => selectedValue !== value)
    } else {
      selectedChildren.push(value)
    }
    this.setState({selectedChildren})
  }
  
  handleParent() {
    if (this.state.selectedChildren.length !== this.childValues.length) {
      this.setState({selectedChildren: this.childValues})
    } else {
      this.setState({selectedChildren: []})
    }
  }
  
  showChildren() {
    this.setState({subVisible: !this.state.subVisible})
  }

  render() {

    const arrowIcon = this.state.subVisible ? 'keyboard-arrow-down' : 'keyboard-arrow-right'
    const selectedIcon = this.state.selectedChildren.length === this.props.subOptions.length ? 'check' : 'square'
    const childrenSelected = this.state.selectedChildren.some(childValue => {
      return this.childValues.includes(childValue)
    })
    
    return (  
      <div>
        <Container>
          <Arrow icon={arrowIcon} color="primary2Color" onClick={() => this.showChildren() }/>
          <Container onClick={() => this.handleParent()}>
            <IconBox>
              {childrenSelected && <Check icon={selectedIcon} size={14} color="primary2Color" />}
            </IconBox>
            <Label>{this.props.label}</Label>
          </Container>
        </Container>
        {this.state.subVisible &&
          <Fragment>
            {this.props.subOptions.map(({ label, value }) => {
              return (
                <LabelChildren>
                  <Option
                    key={value}
                    value={value}
                    checked={this.state.selectedChildren.includes(value)}
                    onChange={() => this.handleChild(value)}
                  >
                    {label}
                  </Option>
                </LabelChildren>
              )
            })}
          </Fragment>
        }   
      </div>
    )
  }
}
